import React from 'react';
import cx from 'clsx';
import styles from '../GameDetailsTop.module.scss';
import { GameTileProps } from '../../../modular-grid/types';
import { isEqual } from 'src/utils/lodash-alternatives';
import { ShouldPreventDefaultForClick } from 'src/components/LaunchStrategiesProvider/utils';
import { GameDetailsTopPropTypes } from '../GameDetailsTop';
import GameLink from '../../../GameLink';

interface GameLaunchLinkPropTypes {
  game: GameTileProps;
  playButtonText: string;
  pageTitle?: string;
  onGameClick: GameDetailsTopPropTypes['onGameButtonClick'];
}

const GameLaunchLink: React.FC<GameLaunchLinkPropTypes> = React.memo(
  ({ game, playButtonText, pageTitle, onGameClick }) => {
    const preventDefaultForGameClick = ShouldPreventDefaultForClick(
      game.integration
    );

    const handleGameClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (preventDefaultForGameClick) e.preventDefault();
      onGameClick &&
        onGameClick({
          game: game,
          gamePosition: 1,
          sectionTitle: 'Game Details',
        });
    };

    return (
      <GameLink
        className={cx(styles.link, styles.linkSolid, styles.headerLink)}
        data-testid="game-details-header-play-button"
        notIndexed={game.notIndexed}
        integration={game.integration}
        url={game.launchUrl}
        onClick={handleGameClick}
        categoryAttributes={{
          title: 'game_details',
          topCategory: pageTitle,
        }}
      >
        {playButtonText}
      </GameLink>
    );
  },
  (prevProps: GameLaunchLinkPropTypes, nextProps: GameLaunchLinkPropTypes) =>
    isEqual(prevProps, nextProps)
);

export default GameLaunchLink;
